<template>
  <div>
    <form form method="post" data-vv-scope="crear">
      <b-row class="mt-4">
        <b-col sm="6">
          <b-form-group>
            <label for="id_nivel"
              >Nivel de Ubicación <span class="text-danger">*</span> </label
            ><br />
            <el-select
              id="id_nivel"
              name="id_nivel"
              v-model="selectedUbicacion.slq_locations_level_id"
              data-vv-as=" "
              size="sm"
              v-validate="'required'"
              @change="validateLevel()"
            >
              <el-option
                v-for="nivelActivo in nivelesActivos.data"
                :label="nivelActivo.description + '  -  Nivel ' + nivelActivo.level"
                :value="nivelActivo.id"
                :key="nivelActivo.id"
              />
            </el-select>
            <span class="text-danger span-error small">
              {{ errors.first("crear.id_nivel") }}
            </span>
          </b-form-group>
        </b-col>
        <b-col sm="6">
          <b-form-group>
            <label for="descripcion"
              >Descripción Ubicación <span class="text-danger">*</span></label
            >
            <b-form-input
              id="descripcion"
              size="sm"
              type="text"
              name="descripcion"
              class="text-uppercase"
              v-model="selectedUbicacion.description"
              data-vv-as=" "
              v-validate="'required'"
            >
            </b-form-input>
            <span class="text-danger span-error small">
              {{ errors.first("crear.descripcion") }}
            </span>
          </b-form-group>
        </b-col>
        <b-col sm="6">
          <b-form-checkbox
            v-model="selectedUbicacion.parent"
            switch
            size="lg"
            :disabled="!level || level.level === 1 || disabled"
            >Seleccionar padre</b-form-checkbox
          >
        </b-col>
        <b-col sm="6" v-if="selectedUbicacion.parent">
          <b-form-group>
            <label for="id_nivel"
              >Ubicación padre <span class="text-danger">*</span></label
            ><br />
            <el-select
              id="parent"
              name="parent"
              v-model="selectedUbicacion.slq_location_id"
              data-vv-as=" "
              size="sm"
              v-validate="
                this.selectedUbicacion.parent
                  ? 'required'
                  : '' || level.level > 1
                  ? 'required'
                  : ''
              "
            >
              <el-option
                v-for="locationActive in locations"
                :label="
                  locationActive.description +
                  '  -  Nivel ' +
                  locationActive.location_level.level
                "
                :value="locationActive.id"
                :key="locationActive.id"
              />
            </el-select>
            <span class="text-danger span-error small">
              {{ errors.first("crear.parent") }}
            </span>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col sm="6" v-if="countriesWithEnterprises.length">
          <b-form-group>
            <label for="id_nivel">País</label><br />
            <el-select
              id="country"
              name="country"
              v-model="country_id"
              data-vv-as=" "
              size="sm"
              clearable
            >
              <el-option
                v-for="country in countriesWithEnterprises"
                :label="country.name"
                :value="country.id"
                :key="country.id"
              />
            </el-select>
          </b-form-group>
        </b-col>

        <b-col sm="6" v-if="countriesWithEnterprises.length && enterprises.length">
          <b-form-group>
            <label for="id_nivel">Enterprise</label><br />
            <el-select
              id="enterprise"
              name="enterprise"
              v-model="enterprise_id"
              data-vv-as=" "
              size="sm"
              v-validate="this.country_id ? 'required' : ''"
              clearable
            >
              <el-option
                v-for="enterprise in enterprises"
                :label="enterprise.name"
                :value="enterprise.id"
                :key="enterprise.id"
              />
            </el-select>
            <span class="text-danger span-error small">
              {{ errors.first("crear.enterprise") }}
            </span>
          </b-form-group>
        </b-col>

        <b-col sm="6" v-if="groups.length && enterprises.length">
          <b-form-group>
            <label for="id_nivel">Grupo</label><br />
            <el-select
              id="group"
              name="group"
              v-model="group_id"
              data-vv-as=" "
              size="sm"
              clearable
              v-validate="this.enterprise_id ? 'required' : ''"
            >
              <el-option
                v-for="group in groups"
                :label="group.name"
                :value="group.id"
                :key="group.id"
              />
            </el-select>
            <span class="text-danger span-error small">
                {{ errors.first("crear.group") }}
              </span>
          </b-form-group>
        </b-col>

        <b-col sm="6" v-if="groups.length && businesses.length">
          <b-form-group>
            <label for="id_nivel">Businesses</label><br />
            <el-select
              id="business"
              name="business"
              v-model="business_id"
              data-vv-as=" "
              size="sm"
              clearable
              v-validate="this.group_id ? 'required' : ''"
            >
              <el-option
                v-for="business in businesses"
                :label="business.name"
                :value="business.id"
                :key="business.id"
              />
            </el-select>
            <span class="text-danger span-error small">
                {{ errors.first("crear.business") }}
              </span>
          </b-form-group>
        </b-col>

        <b-col sm="6" v-if="subBusinesses.length && businesses.length">
          <b-form-group>
            <label for="id_nivel">Sub Businesses</label><br />
            <el-select
              id="sub_business"
              name="sub_business"
              v-model="selectedUbicacion.slq_business_sub_business_id"
              data-vv-as=" "
              size="sm"
              clearable
              v-validate="this.business_id ? 'required' : ''"
            >
              <el-option
                v-for="sub_business in subBusinesses"
                :label="sub_business.name"
                :value="sub_business.id"
                :key="sub_business.id"
              />
            </el-select>
            <span class="text-danger span-error small">
                {{ errors.first("crear.sub_business") }}
              </span>
          </b-form-group>
        </b-col>
      </b-row>
    </form>
    <b-row>
      <b-col>
        <button class="btn btn-primary float-right" @click="nuevaUbicacion()">
          Guardar
        </button>
        <b-button class="btn btn-default float-right mr-2" @click="cancelar">
          Cancelar
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";

export default {
  data() {
    return {
      level: null,
      locations: [],
      disabled: false,
      country_id: null,
      enterprise_id: null,
      group_id: null,
      business_id: null,
    };
  },
  watch: {
    country_id: {
      handler: async function (val) {
        if (val) {
          await this.getCountryByIdAndCompanyId({
            country_id: val,
            company_id: this.$route.params.id,
          });
        } else {
          this.setEnterprises([]);
          this.setGroups([]);
          this.setBusinesses([]);
          this.setSubBusinesses([]);
          this.enterprise_id = null;
          this.group_id = null;
          this.business_id = null;
        }
      },
      deep: true,
    },
    enterprise_id: {
      handler: async function (val) {
        if (val) {
          await this.getEnterpriseByIdAndCompanyId({
            enterprise_id: val,
            company_id: this.$route.params.id,
          });
        } else {
          this.setGroups([]);
          this.setBusinesses([]);
          this.setSubBusinesses([]);
          this.group_id = null;
          this.business_id = null;
        }
      },
      deep: true,
    },
    group_id: {
      handler: async function (val) {
        if (val) {
          await this.getGroupByIdAndCompanyId({
            group_id: val,
            company_id: this.$route.params.id,
          });
        } else {
          this.setBusinesses([]);
          this.setSubBusinesses([]);
          this.business_id = null;
        }
      },
      deep: true,
    },
    business_id: {
      handler: async function (val) {
        if (val) {
          await this.getBusinessByIdAndCompanyId({
            business_id: val,
            company_id: this.$route.params.id,
          });
        } else {
          this.setSubBusinesses([]);
          this.selectedUbicacion.slq_business_sub_business_id = null;
        }
      },
      deep: true,
    },
  },
  methods: {
    async verNivel() {
      this.setFiltroNivel();
      await this.listarNivel(this.$route.params.id);
    },
    async nuevaUbicacion() {
      if (!this.selectedUbicacion.parent) {
        this.selectedUbicacion.slq_location_id = null;
      }
      this.$validator.validateAll("crear").then(async (result) => {
        if (result) {
          await this.crearUbicacion(this.$route.params.id);
          this.resetSelectedUbicacion();
          this.setModal(false);
          this.setEnterprises([]);
          this.setGroups([]);
          this.setBusinesses([]);
          this.setSubBusinesses([]);
        }
      });
    },
    async cancelar() {
      (this.level = null), (this.locations = []), (this.disabled = false);
      this.resetSelectedUbicacion();
      this.resetOptions();
      this.setModal(false);
    },
    validateLevel() {
      this.level = this.nivelesActivos.data.filter(
        (item) => item.id === this.selectedUbicacion.slq_locations_level_id
      );
      this.level = this.level[0];

      if (this.level.level > 1) {
        this.locations = this.locationsActive.filter(
          (item) => item.location_level.level === this.level.level - 1
        );

        this.selectedUbicacion.parent = true;
        this.disabled = true;
      } else {
        this.locations = this.locationsActive;
        this.selectedUbicacion.parent = false;
      }
    },
    ...mapActions("location", [
      "crearUbicacion",
      "listLevels",
      "verListaUbicaciones",
      "listarNivelActivos",
      "crearUbicacionEmpresa",
      "arbolUbicacionesEmpresa",
    ]),
    ...mapMutations("location", [
      "setFiltro",
      "setUbicacionEmpresa",
      "setPaso",
      "setModal",
      "setEnlazarUbicacion",
      "resetSelectedUbicacion",
      "resetSelectedNivel",
      "setIdParent",
      "resetOptions",
    ]),

    ...mapActions("countries", ["getCountryByIdAndCompanyId"]),
    ...mapActions("enterprises", ["getEnterpriseByIdAndCompanyId"]),
    ...mapActions("groups", ["getGroupByIdAndCompanyId"]),
    ...mapActions("businesses", ["getBusinessByIdAndCompanyId"]),

    ...mapMutations("enterprises", ["setEnterprises"]),
    ...mapMutations("groups", ["setGroups"]),
    ...mapMutations("businesses", ["setSubBusinesses", "setBusinesses"]),
  },
  computed: {
    ...mapState("location", [
      "selectedUbicacion",
      "ubicaciones",
      "ubicacionEmpresa",
      "nivelesActivos",
      "id_ubicacion",
      "ubicacionAsig",
      "crearUbic",
      "modal",
      "errorUbic",
      "selectedNivel",
      "locationsActive",
    ]),
    ...mapState("countries", ["countriesWithEnterprises"]),
    ...mapState("enterprises", ["enterprises"]),
    ...mapState("groups", ["groups"]),
    ...mapState("businesses", ["businesses", "subBusinesses"]),
  },
};
</script>
